"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeOptions = exports.theme = void 0;
const styles_1 = require("@material-ui/core/styles");
const variables_1 = __importDefault(require("./variables"));
/**
 * Alcumus theme specifications to implement overrides in your Material UI frontend project
 */
const Breakpoints = (0, styles_1.createTheme)().breakpoints;
exports.theme = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    palette: {
        type: 'light',
        primary: {
            main: variables_1.default.colors.action.primary.default,
            contrastText: variables_1.default.colors.text.secondary,
        },
    },
    typography: {
        h1: {
            [Breakpoints.down('xs')]: {
                fontSize: variables_1.default.fonts.mobile.size.h1,
                lineHeight: variables_1.default.fonts.mobile.lineHeight.h1,
            },
            fontFamily: variables_1.default.fonts.family.heading,
            fontWeight: variables_1.default.fonts.weight.medium,
            fontSize: variables_1.default.fonts.size.h1,
            lineHeight: variables_1.default.fonts.lineHeight.h1,
            letterSpacing: variables_1.default.fonts.letterSpacing.h1,
        },
        h2: {
            [Breakpoints.down('xs')]: {
                fontSize: variables_1.default.fonts.mobile.size.h2,
                lineHeight: variables_1.default.fonts.mobile.lineHeight.h2,
            },
            fontFamily: variables_1.default.fonts.family.heading,
            fontWeight: variables_1.default.fonts.weight.medium,
            fontSize: variables_1.default.fonts.size.h2,
            lineHeight: variables_1.default.fonts.lineHeight.h2,
            letterSpacing: variables_1.default.fonts.letterSpacing.h2,
        },
        h3: {
            [Breakpoints.down('xs')]: {
                fontSize: variables_1.default.fonts.mobile.size.h3,
                lineHeight: variables_1.default.fonts.mobile.lineHeight.h3,
            },
            fontFamily: variables_1.default.fonts.family.heading,
            fontWeight: variables_1.default.fonts.weight.regular,
            fontSize: variables_1.default.fonts.size.h3,
            lineHeight: variables_1.default.fonts.lineHeight.h3,
            letterSpacing: variables_1.default.fonts.letterSpacing.h3,
        },
        h4: {
            [Breakpoints.down('xs')]: {
                fontSize: variables_1.default.fonts.mobile.size.h4,
                lineHeight: variables_1.default.fonts.mobile.lineHeight.h4,
            },
            fontFamily: variables_1.default.fonts.family.heading,
            fontWeight: variables_1.default.fonts.weight.regular,
            fontSize: variables_1.default.fonts.size.h4,
            lineHeight: variables_1.default.fonts.lineHeight.h4,
            letterSpacing: variables_1.default.fonts.letterSpacing.h4,
        },
        h5: {
            [Breakpoints.down('xs')]: {
                fontSize: variables_1.default.fonts.mobile.size.h5,
                lineHeight: variables_1.default.fonts.mobile.lineHeight.h5,
            },
            fontFamily: variables_1.default.fonts.family.heading,
            fontWeight: variables_1.default.fonts.weight.regular,
            fontSize: variables_1.default.fonts.size.h5,
            lineHeight: variables_1.default.fonts.lineHeight.h5,
            letterSpacing: variables_1.default.fonts.letterSpacing.h5,
        },
        h6: {
            [Breakpoints.down('xs')]: {
                fontSize: variables_1.default.fonts.mobile.size.h6,
                lineHeight: variables_1.default.fonts.mobile.lineHeight.h6,
            },
            fontFamily: variables_1.default.fonts.family.heading,
            fontWeight: variables_1.default.fonts.weight.regular,
            fontSize: variables_1.default.fonts.size.h6,
            lineHeight: variables_1.default.fonts.lineHeight.h6,
            letterSpacing: variables_1.default.fonts.letterSpacing.h6,
        },
        overline: {
            fontFamily: variables_1.default.fonts.family.heading,
            fontWeight: variables_1.default.fonts.weight.medium,
            fontSize: variables_1.default.fonts.size.regular,
            lineHeight: variables_1.default.fonts.lineHeight.regular,
            textTransform: 'uppercase',
            letterSpacing: variables_1.default.fonts.letterSpacing.regular,
        },
        body1: {
            fontFamily: variables_1.default.fonts.family.heading,
            fontSize: variables_1.default.fonts.size.regular,
            lineHeight: variables_1.default.fonts.lineHeight.regular,
            letterSpacing: variables_1.default.fonts.letterSpacing.regular,
        },
        body2: {
            fontFamily: variables_1.default.fonts.family.heading,
            fontSize: variables_1.default.fonts.size.small,
            lineHeight: variables_1.default.fonts.lineHeight.small,
            letterSpacing: variables_1.default.fonts.letterSpacing.regular,
        },
        subtitle1: {
            fontFamily: variables_1.default.fonts.family.heading,
            fontSize: variables_1.default.fonts.size.smaller,
            lineHeight: variables_1.default.fonts.lineHeight.smaller,
            letterSpacing: variables_1.default.fonts.letterSpacing.regular,
        },
        subtitle2: {
            fontFamily: variables_1.default.fonts.family.heading,
            fontSize: variables_1.default.fonts.size.xs,
            lineHeight: variables_1.default.fonts.lineHeight.xs,
            letterSpacing: variables_1.default.fonts.letterSpacing.regular,
        },
    },
    overrides: {
        MuiLink: {
            root: {
                fontWeight: variables_1.default.fonts.weight.medium,
                color: variables_1.default.colors.text.default,
                textDecoration: 'underline',
                cursor: 'pointer',
                '&:hover': {
                    color: variables_1.default.colors.interactive.default,
                },
            },
            underlineHover: {
                textDecoration: 'underline',
            },
        },
        MuiButton: {
            contained: {
                fontFamily: variables_1.default.fonts.family.heading,
            },
            sizeSmall: {
                fontSize: variables_1.default.fonts.size.small,
            },
            text: {
                '&:hover': { backgroundColor: variables_1.default.colors.action.tertiary.hover },
                '&:active': {
                    backgroundColor: variables_1.default.colors.action.tertiary.pressed,
                },
                '&:focus': {
                    borderColor: variables_1.default.colors.border.active,
                },
            },
        },
        MuiSelect: {
            select: {
                fontSize: variables_1.default.fonts.size.regular,
                fontFamily: variables_1.default.fonts.family.heading,
                '&$disabled': {
                    backgroundColor: variables_1.default.colors.surface.neutral.disabled,
                },
            },
            selectMenu: {
                fontSize: variables_1.default.fonts.size.regular,
                fontFamily: variables_1.default.fonts.family.heading,
            },
        },
        MuiInputLabel: {
            root: {
                fontSize: variables_1.default.fonts.size.regular,
                fontFamily: variables_1.default.fonts.family.heading,
            },
        },
        MuiInputBase: {
            input: {
                fontSize: variables_1.default.fonts.size.regular,
                fontFamily: variables_1.default.fonts.family.heading,
            },
            root: {
                fontSize: variables_1.default.fonts.size.regular,
                color: variables_1.default.colors.text.default,
            },
        },
        MuiTableCell: {
            root: {
                fontSize: variables_1.default.fonts.size.regular,
                color: variables_1.default.colors.text.default,
                padding: variables_1.default.spacing(1),
            },
            head: {
                backgroundColor: '#F4F5F6',
                color: variables_1.default.colors.text.default,
                fontSize: variables_1.default.fonts.size.small,
            },
            body: { color: variables_1.default.colors.text.default },
        },
        MuiTooltip: {
            tooltip: {
                fontSize: variables_1.default.fonts.size.small,
                backgroundColor: variables_1.default.colors.text.default,
            },
        },
    },
};
exports.ThemeOptions = exports.theme;
/**
 * Material UI theme with overrides for Alcumus Style Guide implementation
 */
const AlcumusTheme = (0, styles_1.createTheme)(exports.theme);
exports.default = AlcumusTheme;
